import { mirrorEntries, type MirrorEntry } from "@/mocks/home";

type MirrorCardProps = {
  entry: MirrorEntry;
  index: number;
};

function MirrorCard({ entry, index }: MirrorCardProps) {
  const isOnline = entry.status === "在线";

  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-primary-300">
      <div className="relative aspect-[4/5] w-full overflow-hidden md:aspect-[5/4]">
        <img
          src={entry.image}
          alt={`${entry.name} 的封面视觉`}
          title={`黑料地址 ${entry.name} 镜像站 备用入口`}
          className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.03]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent"></div>

        <span className="absolute right-4 top-4 font-heading text-3xl font-black text-background-50/70">
          {String(index + 1).padStart(2, "0")}
        </span>

        <div className="absolute inset-x-5 bottom-5">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/90 px-3 py-1 font-label text-xs font-medium text-foreground-900">
            <span
              className={`h-1.5 w-1.5 rounded-full ${
                isOnline ? "bg-accent-500 animate-soft-pulse" : "bg-primary-500"
              }`}
            ></span>
            {entry.status}
          </span>
          <h3 className="mt-3 font-heading text-xl font-bold text-background-50 md:text-2xl">
            {entry.name}
          </h3>
          <p className="mt-1 font-label text-xs text-background-200 md:text-sm">{entry.host}</p>
        </div>
      </div>

      <div className="flex flex-1 flex-col gap-4 p-5 md:p-7">
        <div className="flex flex-wrap items-center gap-2">
          <span className="rounded-full bg-secondary-100 px-3 py-1 font-label text-xs text-secondary-900">
            {entry.region}
          </span>
          <span className="rounded-full bg-secondary-100 px-3 py-1 font-label text-xs text-secondary-900">
            延迟 {entry.latency}
          </span>
          <span className="rounded-full bg-background-100 px-3 py-1 font-label text-xs text-foreground-600">
            {entry.updated}
          </span>
        </div>

        <p className="text-sm leading-relaxed text-foreground-700">{entry.note}</p>

        <button
          type="button"
          className="mt-auto inline-flex w-fit cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-5 py-2.5 font-label text-sm font-semibold text-foreground-900 transition-colors duration-200 hover:border-primary-500 hover:text-primary-600"
        >
          <i className="ri-external-link-line text-base"></i>
          进入该入口
        </button>
      </div>
    </article>
  );
}

export default function MirrorFlow() {
  return (
    <section id="mirrors" className="w-full bg-background-100">
      <div className="mx-auto w-full px-4 py-20 md:px-8 md:py-32">
        <div className="mb-12 max-w-2xl md:mb-16">
          <p className="font-label text-xs tracking-[0.3em] text-accent-600 md:text-sm">
            AVAILABLE MIRRORS
          </p>
          <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            可用镜像域名
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
            下面列出当前黑料地址镜像站与备用入口的可用情况。每条线路都标注了区域、延迟与更新时间，
            建议至少收藏两条以上，做到防封备用、随时切换。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:gap-8 lg:grid-cols-2">
          {mirrorEntries.map((entry, index) => (
            <MirrorCard key={entry.id} entry={entry} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}